import { render, staticRenderFns } from "./OutBoundBoxExchange.vue?vue&type=template&id=302a779a"
import script from "./OutBoundBoxExchange.vue?vue&type=script&lang=js"
export * from "./OutBoundBoxExchange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports